import { Form, Col, Row, Button, Container } from "react-bootstrap";
import { FaTemperatureHigh, FaWhatsapp, FaPhone } from "react-icons/fa";
import { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import check from "../../assets/img/check.png";
import { useParams } from "react-router-dom";

import loadingImg from "../../assets/img/loading.svg";
import { sendPostRequest, sendPostRequestV2 } from "../../config/desol";

const Formulario = () => {
  const [loading, setLoading] = useState(true);
  // console.log(vehicles);

  const query = new URLSearchParams(window.location.search);
  const utm_source = (query && query.get("utm_source")) || sessionStorage.getItem("utm_source");
  const utm_medium = (query && query.get("utm_medium")) || sessionStorage.getItem("utm_medium");

  const [validated, setValidated] = useState(false);
  const [tipoTemplate, setTipoTemplate] = useState("comercialNuevaRanger");
  const [desolChannel, setDesolChannel] = useState("1002 - FORD_COMERCIAL_DE_VENTAS_TRADICIONAL");
  const [status, setStatus] = useState(null);
  const [toSend, setToSend] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
    origen: `LANDING NUEVA RANGER - ${utm_source ? utm_source : ""}  ${utm_medium ? utm_medium : ""}`,
  });

  //console.log(toSend);

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
  };

  function objectToFormData(obj) {
    const formData = new FormData();

    Object.entries(obj).forEach(([key, value]) => {
      formData.append(key, value);
    });

    return formData;
  }

  const onSubmit = (e) => {
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      // console.log("no valido");
    }
    setValidated(true);
    if (form.checkValidity() === true) {
      e.preventDefault();
      setStatus("cargando");

      const data = {
        Apellido: toSend.name,
        Email: toSend.email,
        Telefono: toSend.phone,
        Canal: "Venta directa",
        Motivo: toSend.comments,
        OrigenLead: `Landing_NuevaRanger_Convencional - ${utm_source} - ${utm_medium}`,
        CommercialCampaign: "C12_FORD_LANDINGS",
        Campaign: "C12_FORD_LANDINGS",
        Modelo_Pedido: toSend.vehicle,
      };

      // API DESOL (sendPostRequestV2 internamente también envía a Tecnóm)
      // Preparar datos completos para Tecnóm que se enviarán a través de sendPostRequestV2
      const tecnomFormData = {
        ...toSend,
        brand: "FORD",
        vModelo: "RANGER",
        vVersion: toSend.vehicle,
        tipoPlan: "venta directa",
        utm_source: utm_source,
        utm_medium: utm_medium,
        desolChannel: "FORD ",
      };

      // sendPostRequestV2 envía a Tecnóm con los datos del formulario
      sendPostRequestV2(tecnomFormData)
        .then((response) => {
          setStatus("ok");

          setTimeout(() => {
            setValidated(false);
            setToSend({
              ...toSend,
              name: "",
              email: "",
              phone: "",
              comments: "",
              medio: "",
              horario: "",
              vehicle: "",
              origen: "",
              tipo_financiacion: "",
            });
            // Construir la URL con origen CONSULTA WEB
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("utm_source", "DOMINIO ORGANICO");
            const urlWithUtm = currentUrl.toString();

            // Construir el mensaje de WhatsApp
            const whatsappMessage = `Hola, me gustaría hacer una consulta.\n${urlWithUtm}`;
            const encodedMessage = encodeURIComponent(whatsappMessage);
            window.location.href = `https://api.whatsapp.com/send?phone=5493513527817&text=${encodedMessage}`;
          }, 2000);
        })
        .catch((error) => {
          setStatus("error");
          setTimeout(() => {
            setStatus(null);
          }, 2000);
        });
    }
  };

  return (
    <Container id="form">
      <>
        {status === null && (
          <>
            <Form onSubmit={onSubmit} noValidate validated={validated}>
              <Row>
                <Col md={3} className="pb-3">
                  <label className="pb-3">Nombre y apellido *</label>
                  <Form.Control
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Nombre completo"
                    value={toSend.name}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={3} className="pb-3">
                  <label className="pb-3">Número de celular *</label>
                  <Form.Control
                    id="phone"
                    name="phone"
                    type="text"
                    placeholder="0351 X XXXXXX"
                    value={toSend.phone}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={3} className="pb-3">
                  <label className="pb-3">Email *</label>
                  <Form.Control
                    id="email"
                    name="email"
                    type="email"
                    placeholder="email@email.com"
                    value={toSend.email}
                    onChange={handleChange}
                    required
                  />
                </Col>
                <Col md={3} className="pb-3">
                  <label className="pb-3"></label>
                  <div>
                    <Button type="submit" className="btn-black mt-3">
                      Enviar
                    </Button>
                  </div>
                </Col>
              </Row>
              {/* 
              <Row>
                <Col md={12} className="pb-3">
                  <label className="pb-3">Dejanos tu consulta</label>
                  <textarea
                    className="form-control inputConsulta"
                    placeholder="Comentarios..."
                    name="comments"
                    id="comments"
                    rows="4"
                    onChange={handleChange}
                    value={toSend.comments}
                  >
                    {toSend.comments}
                  </textarea>
                </Col>
              </Row> */}

              {/* <Row>
                <Col md={12} className="pb-3 d-flex justify-content-end ">
                  <div>
                    <Button type="submit" className="btn-black">
                      Enviar
                    </Button>
                  </div>
                </Col>
              </Row> */}
            </Form>
          </>
        )}

        {status === "cargando" && (
          <div className="msgHeader text-center pt-5 pb-5" id="enviando-mensaje">
            <img src={loadingImg} alt="Cargando..." className="pb-3" style={{ maxWidth: "150px" }} />
            <p style={{ color: "#FFF" }}>Enviando mensaje...</p>
          </div>
        )}

        {status === "ok" && (
          <div className="msgHeader text-center pt-5 pb-5" id="mensaje-enviado">
            <div>
              <img src={check} alt="Enviado" className="img-fluid" style={{ marginBottom: "20px", maxWidth: "60px" }} />
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "22px",
                  marginBottom: "0",
                  textAlign: "center",
                  color: "#fff",
                }}
              >
                Ya enviamos tu consulta.
              </p>
              <p style={{ textAlign: "center", color: "#fff" }}>
                En las próximas 2 horas, un asesor te contactará para seguir gestionando tu consulta
              </p>
            </div>
          </div>
        )}

        {status === "error" && (
          <div className="msgHeader pt-5 pb-5" id="mensaje-error">
            <div>
              <p
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "22px",
                  marginBottom: "0",
                  textAlign: "center",
                }}
              >
                Se ha producido un error
              </p>
              <p style={{ textAlign: "center", color: "#fff" }}>Vuelva a intentarlo mas tarde</p>
            </div>
          </div>
        )}
      </>
    </Container>
  );
};

export default Formulario;
